<template>
  <div>
    <NavBar />
    <div class="container">
      <v-btn class="v-primary mb-2" v-on:click="handleToBack">
        <span class="fa fa-arrow-left"></span> Voltar
      </v-btn>
      <v-card>
        <v-card-title>
          <span class="text-muted">Perfil:</span>
          <span class="ml-1">{{ name }}</span>
        </v-card-title>
        <div class="container">
          <b-overlay :show="loading" opacity="0.99">
            <form v-on:submit="update" method="post">
              <WarningMessage
                v-if="!permissions.user_profile.edit"
                message="Você não tem permissão para modificar perfis de usuários"
              />
              <div class="row">
                <div class="col-md-12">
                  <input
                    :disabled="!permissions.user_group.edit"
                    type="text"
                    ref="autofocus"
                    v-model="name"
                    class="form-control"
                  />
                </div>
                <div class="col-md-12">
                  <h6>
                    <span class="text-muted">Criação:</span>
                    {{ formatDate(created_at) }}
                  </h6>
                  <h6>
                    <span class="text-muted">Última alteração:</span>
                    {{ formatDate(updated_at) }}
                  </h6>
                </div>
                <div class="col-md-12 text-right">
                  <v-btn
                    v-if="permissions.user_profile.remove"
                    class="v-danger m-1"
                    @click="confirmDeleteDialog"
                  >
                    <span class="fa fa-times-circle"></span> Apagar
                  </v-btn>
                  <v-btn
                    v-if="permissions.user_profile.edit"
                    :disabled="loadingUpdate"
                    type="submit"
                    class="v-success m-1"
                  >
                    <span class="fa fa-check"></span>
                    {{ loadingUpdate ? "Carregando" : "Salvar" }}
                  </v-btn>
                </div>
              </div>
            </form>
          </b-overlay>
          <hr />
          <h4 class="text-center">Permissões</h4>
          <b-overlay :show="loadingPermissions" opacity="0.99">
            <div class="text-center" v-if="allPermissions.length == 0">
              <span>Não foram definido acessos para o perfil!!!</span>
              <br />
              <vs-button
                @click="handleToPermissions"
                class="v-secondary"
                type="relief"
                >Adicionar</vs-button
              >
            </div>
            <v-data-table
              dense
              :headers="[
                { text: 'Nome', value: 'name' },
                {
                  text: 'CADASTRAR',
                  value: 'writers',
                },
                {
                  text: 'VISUALIZAR',
                  value: 'readers',
                },
                {
                  text: 'EDITAR',
                  value: 'editors',
                },
                {
                  text: 'REMOVER',
                  value: 'removers',
                },
              ]"
              :items="allPermissions"
              class="elevation-1"
              :footer-props="{
                'items-per-page-options': [10, 75, 100],
                'items-per-page-text': 'Mostrar',
              }"
              @click:row="handleGoToPermission"
            >
              <template v-slot:[`item.writers`]="{ item }">
                <i v-if="item.writers" class="fa fa-check c-success"></i>
                <i v-else class="fa fa-close c-danger"></i>
              </template>
              <template v-slot:[`item.readers`]="{ item }"
                ><i v-if="item.readers" class="fa fa-check c-success"></i>
                <i v-else class="fa fa-close c-danger"></i>
              </template>
              <template v-slot:[`item.editors`]="{ item }">
                <i v-if="item.editors" class="fa fa-check c-success"></i>
                <i v-else class="fa fa-close c-danger"></i
              ></template>
              <template v-slot:[`item.removers`]="{ item }">
                <i v-if="item.removers" class="fa fa-check c-success"></i>
                <i v-else class="fa fa-close c-danger"></i
              ></template>
            </v-data-table>
          </b-overlay>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import api from "../services/api";

import routes from "../routes";

import toast from "../components/ToastNotification";

import { formatDate } from "../functions/format";
import { adminData } from "../lib/functions";

export default {
  name: "Profile",
  components: {
    NavBar,
  },
  data() {
    return {
      permissions: {},
      id: "",
      name: "",
      created_at: "",
      updated_at: "",
      loading: true,
      loadingPermissions: true,
      loadingUpdate: false,
      allPermissions: [],
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    async retrieve() {
      this.permissions = adminData().permissions;

      const { id } = routes.history.current.params;

      if (!id) {
        return routes.push({ name: "profiles" });
      }

      this.id = id;

      await this.get();
      await this.getPermissions();
    },
    async get() {
      try {
        this.loading = true;

        const { id } = this;

        const response = await api.get("/admin/profile/get", {
          params: { id },
        });

        const { profile } = response.data;

        this.id = profile.id;
        this.name = profile.name;
        this.created_at = profile.created_at;
        this.updated_at = profile.updated_at;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getPermissions() {
      try {
        this.loadingPermissions = true;

        const { id } = this;

        const response = await api.get("/admin/profile/permissions/all", {
          params: { id },
        });

        const { permissions } = response.data;

        var array = [];

        for (const item of permissions) {
          if (item.writers || item.readers || item.editors || item.removers) {
            array.push(item);
          }
        }

        this.allPermissions = array;

        this.loadingPermissions = false;
      } catch (error) {
        console.log(error);
      }
    },
    async update(event) {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const { id, name } = this;

        let params = { id, name };

        const response = await api.put("/admin/profile/update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.get();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    confirmDeleteDialog() {
      this.$vs.dialog({
        color: "warning",
        title: "Confirmação",
        text:
          "Deseja realmente apagar o perfil? Só pode apagar caso não exista vinculo do perfil com administrador!",
        acceptText: "Confirmar",
        accept: () => this.delete(),
      });
    },
    async delete() {
      try {
        const { id } = this;

        let data = { id };

        const response = await api.delete("/admin/profile/delete", {
          data,
        });

        const { error, errors } = response.data;

        if (!error) {
          routes.push({ name: "profiles" });
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleToBack: () => routes.go(-1),
    handleToPermissions: () => routes.push({ name: "permissions" }),
    handleGoToPermission: ({ id }) =>
      routes.push({
        name: "permission",
        params: {
          id,
        },
      }),
  },
};
</script>